import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import VinEntry from '../../generic/VinEntry'
import GoButton from './GoButton'
import { AnchorButton } from '../../generic/Basics'
import { FlexRowDiv } from '../../generic/Basics'
import { fontSize3XSmall, fontSize2XSmall, fontWeightSemibold, fontFamilyOpenSans, redLight10 } from '../../../constants/principles'
import Error from '../../generic/Error'
import { LandingPageNumber } from '../../../constants'
import IneligibleDR from './../../generic/IneligibleDR'

export default ({
  setShowModal,
  errorMessage,
  isErrorNeedUseTradeInValue,
  vinActiveDealerUrl,
  isVinActiveDealer,
  year,
  make,
  model,
  trim,
  error,
  urlState,
  offer,
  globalState,
  updateGlobalState,
  onChange,
  displayYMM,
  onClick,
  isAdmin,
  setBackToVin,
  submitVinNoForm,
  navigateToNewOfferWithVin,
  argoButtonEnabled,
  loadingInfo,
  offerCode
}) => {
  const vin = globalState.vin || urlState.vin || (offer && offer.prospect.vehicle.vin)
  const [localError, setLocalError] = useState(false)
  const showIneligibleDrButton = offerCode.toUpperCase() !== 'TC'
  const { submitVinCount = 0 } = globalState
  const vinNo = urlState.vin
  const step = urlState.p
  const stepsame = !urlState.pp
  const isLoading = loadingInfo['Lookup vin']
  const isNewVinFromResubmit =
    (globalState && globalState.isNewVinFromResubmit) || (!isAdmin && offer && offer.canBeResubmitted && offer.prospect && offer.prospect.isConsumerOffer && offer.prospect.vehicle && offer.prospect.vehicle.vin && offer.prospect.vehicle.vin !== vin)

  const onClickNew = e => {
    const hasError =
      vin?.length !== 17 ||
      // Error only if globalState VIN matches previous, allows reuse of VIN from url
      globalState.vin === globalState.previousVin
    onClick(e, false, 'VIN', hasError)
    updateGlobalState({ previousVin: vin, mileageRangeValidated: false })
    setLocalError(hasError)
  }

  const onClickResubmitWithNewVIN = e => {
    updateGlobalState({ isNewVinFromResubmit, previousVin: vin, entry: 'vin', mileageRangeValidated: false })
    urlState.amQ = globalState.previousVin !== vin ? undefined : urlState.amQ
    setBackToVin(false)
    submitVinNoForm(globalState.vin || urlState.vin || (offer && offer.prospect.vehicle.vin))
    navigateToNewOfferWithVin()
    setTimeout(setShowModal)
    setLocalError(!(vin && vin.length === 17))
  }

  const onClickInput = e => {
    updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'first_trade_in_start' })
  }

  useEffect(() => {
    const handleUp = event => {
      if (event.target.id !== 'vin-entry') {
        return
      }
      const { keyCode } = event

      if (keyCode === 9) {
        updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'first_trade_in_start' })
      }
    }

    window.addEventListener('keyup', handleUp)
    return () => window.removeEventListener('keyup', handleUp)
  }, [updateGlobalState])

  useEffect(() => {
    // if the form is auto loaded with a vin and it is first hit on page
    if (submitVinCount === 0 && vinNo && step === LandingPageNumber && stepsame && !offer) updateGlobalState({ vinNo, submitVinCount: submitVinCount + 1, fromLanding: true })
  }, [updateGlobalState, submitVinCount, vinNo, step, stepsame, offer])

  return (
    <>
      <StyledContainer>
        <StyledTextDiv>
          <VinEntry
            testId="bi-tb-vin-entry"
            vin={vin}
            onClick={onClickInput}
            onChange={vin => onChange({ vin }, 2)}
            onScanSuccess={vin => onClick({}, false, 'VIN', !(vin && vin.length === 17), vin)}
            error={error}
            setError={setLocalError}
            isAdmin={isAdmin}
            updateGlobalState={updateGlobalState}
          />
        </StyledTextDiv>

        <GoButton isLoading={isLoading} onClick={isNewVinFromResubmit ? onClickResubmitWithNewVIN : onClickNew} argo={argoButtonEnabled} />
      </StyledContainer>
      {!error && !localError && displayYMM && <InstructionDiv>{`Please enter your VIN or select your vehicle's information below.`}</InstructionDiv>}
      {error && !errorMessage && !isErrorNeedUseTradeInValue && !!isVinActiveDealer && (
        <FullWidthDiv>
          <Error
            text={
              <StyledUl>
                <li> {"Your vehicle doesn't qualify for an Instant Cash Offer because it is listed for sale by a dealer."} </li>
              </StyledUl>
            }
            id={'vin-error'}
            testId={'bi-lb-vin-error'}
            leftAlign={true}
            isError={true}
          />
          <StyledContaierLink>
            <StyledLink href={vinActiveDealerUrl} target="_blank" rel="noopener noreferrer">
              Click here to see listing
            </StyledLink>
          </StyledContaierLink>
        </FullWidthDiv>
      )}
      {error && errorMessage && !isErrorNeedUseTradeInValue && (
        <FullWidthDiv>
          <Error text={errorMessage} id={'vin-error'} testId={'bi-lb-vin-error'} leftAlign={true} isError={true} />
        </FullWidthDiv>
      )}
      {error && isErrorNeedUseTradeInValue && !errorMessage && showIneligibleDrButton && (
        <FullWidthDiv>
          <Error text="Your vehicle doesn't qualify for an Instant Cash Offer." id={'vin-error'} testId={'bi-lb-vin-error'} leftAlign={true} isError={true} />

          <IneligibleDR reason="Your vehicle doesn't qualify for an Instant Cash Offer." vin={vin} year={year && year.yearId} make={make && make.makeId} model={model && model.modelId} trim={trim && trim.trimId} />
        </FullWidthDiv>
      )}
      {error && isErrorNeedUseTradeInValue && !errorMessage && !showIneligibleDrButton && (
        <FullWidthDiv>
          <Error text="Your vehicle doesn't qualify for an Instant Cash Offer." id={'vin-error'} testId={'bi-lb-vin-error'} leftAlign={true} isError={true} />
        </FullWidthDiv>
      )}
      {(error || localError) && !isErrorNeedUseTradeInValue && !errorMessage && !isVinActiveDealer && (
        <FullWidthDiv>
          <Error
            text={
              (vin && vin.length === 17) || displayYMM ? (
                <>
                  {"We couldn't find that VIN."} <br />
                  {`Please re-enter it${displayYMM ? " or select your vehicle's information below" : ''}.`}
                </>
              ) : (
                'A VIN must contain exactly 17 characters. Please re-enter the VIN.'
              )
            }
            id={'vin-error'}
            testId={'bi-lb-vin-error'}
            leftAlign={true}
            isError={true}
          />
        </FullWidthDiv>
      )}
      {(!displayYMM || !errorMessage) && (
        <StyledVin
          data-testid={'bi-btn-where-is-my-vin'}
          onClick={() => {
            updateGlobalState({ fireAnalytics: 'whereismyvin_lnk' })
            setShowModal('VIN')
          }}>
          {!errorMessage && ' Where is my VIN?'}
        </StyledVin>
      )}
    </>
  )
}

const FullWidthDiv = styled.div`
  width: 100%;
`
const InstructionDiv = styled(FullWidthDiv)`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  font-family: ${fontFamilyOpenSans};
  padding-top: 8px;
`
const StyledVin = styled(AnchorButton)`
  padding-top: 8px;
  font-size: ${fontSize3XSmall};
`
const StyledContainer = styled(FlexRowDiv)`
  width: 100%;
  align-items: unset;
`
const StyledTextDiv = styled.div`
  width: 233px;
  margin-right: 8px;
`
const StyledLink = styled.a`
  color: ${redLight10};
  text-decoration: underline;
`
const StyledUl = styled.ul`
  display: inline;
  list-style-type: none;
  padding: 0;
  margin-bottom: 2px;
`
const StyledContaierLink = styled.div`
  font-weight: 600;
  text-align: center;
`
